import React, { useState, useEffect } from "react";
import {
  Modal,
  Table,
  notification,
  Card,
  Button,
  Form,
  Space,
  Input,
  InputNumber,
  Popconfirm,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { apiGetTax, apiPostTax, apiDeleteTax } from "api/api";

const TaxSetting = () => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();

  const [dataSource, setDataSource] = useState([
    { prefix: "SKDFDF", id: "302SDD@#", amount: 12 },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [record, setRecord] = useState({});
  const [isEditMode, setIsEditMode] = useState(false); // 編輯or新增 彈窗共用
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);

  // # 獲取dataSource
  const fetchData = async () => {
    setIsTableLoading(true);
    try {
      const res = await apiGetTax();
      const { content } = res.data;
      setDataSource(content);
    } catch (error) {
      api.error({
        message: `${error.response.data.message}`,
        introduction: "",
      });
    } finally {
      setIsTableLoading(false);
    }
  };

  // # 新增dataSource
  const handleCreate = async (data) => {
    console.log("傳來", data);
    const { name, issuer, prefix, format, amount, originalSerialNumber } = data;
    try {
      const res = await apiPostTax({
        name,
        issuer,
        prefix,
        format,
        amount,
        originalSerialNumber,
      });
      api.success({
        message: `新增成功`,
        introduction: `${res.data.message}`,
      });
      setIsModalOpen(false);
      fetchData();
    } catch (error) {
      api.error({
        message: `${error.response.data.message}` || "新增失敗",
        introduction: "",
      });
    } finally {
      setIsCreateLoading(false);
    }
  };

  // # 更新dataSource
  const handleUpdate = async (data) => {
    // try {
    //   const res = await api();
    //   api.success({
    //     message: `更新成功`,
    //     introduction: `${res.data.message}`,
    //   });
    // } catch (error) {
    //   api.error({
    //     message: `更新失敗`,
    //     introduction: "",
    //   });
    // } finally {
    //   setIsUpdateLoading(false);
    // }
  };

  // # 刪除 dataSource
  const handleDelete = async (record) => {
    const { id } = record;

    setIsTableLoading(true);
    try {
      const res = await apiDeleteTax({
        id,
      });
      api.success({
        message: `刪除成功`,
        introduction: `${res.data.message}`,
      });
      setTimeout(() => {
        fetchData();
      }, [500]);
    } catch (error) {
      api.error({
        message: `${error.response.data.message || "刪除失敗"}`,
        introduction: "",
      });
      setTimeout(() => {
        fetchData();
      }, 500);
    } finally {
      setIsTableLoading(false);
    }
  };

  // # 點及編輯按鈕
  const handleEdit = (record) => {
    setRecord(record);
    setIsModalOpen(true);
  };

  // # 彈窗開啟
  const showModal = () => {
    setIsModalOpen(true);
  };

  // # 彈窗關閉
  const handleCancel = () => {
    setRecord({});
    setIsModalOpen(false);
  };

  // # 提交表單按鈕
  const onFinish = (values) => {
    console.log("送出", values);
    if (isEditMode) {
      setIsUpdateLoading(true);
      handleUpdate(values);
    } else {
      setIsCreateLoading(true);
      handleCreate(values);
    }
  };

  // # 提交表單按鈕（失敗）
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const columns = [
    {
      title: "核准單位",
      dataIndex: "issuer",
      key: "issuer",
    },
    {
      title: "名稱",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "PreFix前綴",
      dataIndex: "prefix",
      key: "prefix",
    },
    {
      title: "Format格式",
      dataIndex: "format",
      key: "format",
    },
    {
      title: "數量",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "起始號",
      dataIndex: "originalSerialNumber",
      key: "originalSerialNumber",
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <Space>
            {/* <Button type="primary" onClick={() => handleEdit(record)}>
              編輯
            </Button> */}
            <Popconfirm
              title="刪除稅務"
              description="確定要刪除該稅務選項？"
              onConfirm={() => handleDelete(record)}
              onCancel={(e) => console.log("e", e)}
              okText="是"
              cancelText="否"
            >
              <Button type="default" className="bg-red-500 text-white">
                刪除
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  // # 觀察 record 決定現在是編輯模式還是新建模式
  useEffect(() => {
    if (Object.keys(record).length == 0) setIsEditMode(false);
    else {
      setIsEditMode(true);
    }
  }, [record]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="w-full">
        {contextHolder}
        <h2 className="text-Gray-8 mb-0">稅務設定</h2>
        <Card
          title={
            <h3 className="text-left">
              稅務選項 &nbsp;
              <Tooltip title="若資料錯誤，請先刪除後新增">
                <span>
                  <InfoCircleOutlined />
                </span>
              </Tooltip>
            </h3>
          }
          className="text-center mt-5 rounded-3xl px-0 pt-6 min-h-[calc(100vh-250px)]"
          extra={
            <Button type="primary" onClick={showModal}>
              新增
            </Button>
          }
        >
          <Table
            loading={isTableLoading}
            dataSource={dataSource}
            columns={columns}
            scroll={{ x: "max-content" }}
          ></Table>
        </Card>
      </div>
      <Modal
        title={isEditMode ? "編輯" : "新增"}
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        destroyOnClose={true}
        width={800}
        initialValues={isEditMode ? record : null}
      >
        <Form
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          // layout="vertical"
          variant="filled"
          size="large"
          form={form}
          preserve={false}
          initialValues={{
            ...record,
            issuer:
              "臺北市稅捐稽徵處中山分處113年8月28日北市稽中山乙字第1134106460號",
          }}
          labelCol={{ span: 3 }}
        >
          <Form.Item name="issuer" label="核准單位">
            <Input></Input>
          </Form.Item>
          <Form.Item name="name" label="名稱">
            <Input></Input>
          </Form.Item>

          <Form.Item name="prefix" label="PreFix前綴">
            <Input placeholder="SKFTPE"></Input>
          </Form.Item>
          <Form.Item name="format" label="Format格式">
            <Input placeholder="xxxxxx"></Input>
          </Form.Item>
          <Form.Item name="amount" label="數量">
            <InputNumber
              className="w-full"
              controls={false}
              min={0}
            ></InputNumber>
          </Form.Item>
          <Form.Item name="originalSerialNumber" label="起始號">
            <InputNumber
              className="w-full"
              controls={false}
              min={0}
            ></InputNumber>
          </Form.Item>
          <Form.Item className="text-right">
            <Space>
              <Button type="default" onClick={() => handleCancel()}>
                取消
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={isEditMode ? isUpdateLoading : isCreateLoading}
              >
                {isEditMode ? "更新" : "建立"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default TaxSetting;
